import { GetRowIdParams } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';
import { AgTable } from '../../../components/AgTable/AgTable';
import { FadeInGridWrapper } from '../../../components/grid-renderers/FadeInGridWrapper';
import { RubricConfig } from '../../../schemas/Rubric.schema';
import {
  defaultRubricConfigColDefs,
  useRubricConfigColumnDefs,
  useRubricConfigExportParams,
} from './RubricConfigColumnDefs';

interface IRubricConfigGridProps {
  data: RubricConfig[];
}
export function RubricConfigGrid({ data }: IRubricConfigGridProps) {
  const colDefs = useRubricConfigColumnDefs();
  const defaultColDef = useMemo(() => defaultRubricConfigColDefs(), []);
  const { exportParams } = useRubricConfigExportParams();
  const getRowId = useCallback((params: GetRowIdParams) => params.data?.id ?? '', []);

  return (
    <div style={{ height: '80dvh', paddingTop: '2rem' }}>
      <FadeInGridWrapper>
        <AgTable
          columnDefs={colDefs}
          rowData={data}
          defaultColDef={defaultColDef}
          defaultExcelExportParams={exportParams}
          defaultCsvExportParams={exportParams}
          rowGroupPanelShow='never'
          getRowId={getRowId}
        />
      </FadeInGridWrapper>
    </div>
  );
}
